

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class BankMovementConcept_ManagedObject

class BankMovementConcept_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: analyticAccountName
    set analyticAccountName(value:string) {
        this.setValueForKey(value, 'analyticAccountName');
    }
    get analyticAccountName():string {
        return this.valueForKey('analyticAccountName');
    }
    set analyticAccountNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'analyticAccountName');
    }
    get analyticAccountNamePrimitiveValue():string {
        return this.primitiveValueForKey('analyticAccountName');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
    // Relationship: analyticAccount
    set analyticAccount(value:AnalyticAccount) {
        this.setValueForKey(value, 'analyticAccount');
    }
    get analyticAccount():AnalyticAccount {
        return this.valueForKey('analyticAccount') as AnalyticAccount;
    }
}
